export default {"src":"/_next/static/media/pills-medicine.a2f4bcf5.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};